import React from 'react';
import { app } from './base';
import Loader from 'react-loader-spinner';
import { Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

function ContentThree() {
  const [loading, setLoading] = React.useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const storageRef = app.storage();
    var gsReference = storageRef.refFromURL(
      'gs://res-dwn.appspot.com/Karthik_sista_2020.PDF'
    );
    gsReference
      .getDownloadURL()
      .then(function (url) {
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function (event) {
          var a = document.createElement('a');
          a.href = window.URL.createObjectURL(xhr.response);
          a.download = 'KARTHIK-SISTA';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          var blob = xhr.response;
          console.log(blob, 'BLOB');
          setLoading(false);
        };
        xhr.open('GET', url);
        xhr.send();
      })
      .catch(function (error) {
        // Handle any errors
      });
  };

  return loading ? (
    <div>
      <span className="resume-text">Downloading....</span>

      <Loader
        type="Puff"
        color="#fff"
        height={100}
        width={100}
        timeout={5000}
      />
    </div>
  ) : (
    <>
      <form onSubmit={onSubmit}>
        <span className="resume-text">
          Wanna know more about my professional life ?
        </span>
        <span className="resume-text">Download My Resume</span>
        <Button
          type="submit"
          variant="contained"
          color="default"
          startIcon={<CloudDownloadIcon />}
        >
          Download
        </Button>
      </form>
    </>
  );
}

export default ContentThree;
